import React, { FC } from 'react'
import InlineSVG from 'react-inlinesvg/esm'
import { Link } from 'react-router-dom'
import AuthScreens from '../../AuthScreens'
import GuestWrapper from '../guest-wrapper/GuestWrapper'

interface Props { }

const VerificationSuccess: FC<Props> = (props) => {
  return (
    <GuestWrapper>
      <div className='d-flex flex-column align-items-stretch'>
        <InlineSVG src={'/media/icons/padma/IconMail.svg'} className='align-self-center mb-10' />
        <div className='text-center mb-10'>
          {/* begin::Title */}
          <h1 className='text-dark mb-3'>Password Berhasil diubah</h1>
          {/* end::Title */}

          {/* begin::Link */}
          <div className='text-gray-400 fw-bold fs-4'>
            Silakan kembali ke login untuk melanjutkan
          </div>
          {/* end::Link */}
        </div>
        <Link to={AuthScreens.LOGIN_EMAIL.PATH} className='btn btn-lg btn-secondary w-100 mb-5'>
          <span className='indicator-label'>Kembali ke Login</span>
        </Link>
      </div>
    </GuestWrapper>
  )
}

export default VerificationSuccess
